<mat-progress-spinner style="margin-left: auto; margin-right: auto; position: relative; top: 50%;" [diameter]="diameter" [mode]="mode" data-cy="progress-spinner"></mat-progress-spinner>
